import { Link } from "react-router-dom";
import type { CustomerWithSite } from "./buildingRules";
import type { CustomerDetails } from "./useBuildings";

interface Props {
  customer: CustomerWithSite;
  details?: CustomerDetails;
  loading: boolean;
  canDelete: boolean;
  onEdit: (customer: CustomerWithSite) => void;
  onDelete: (customer: CustomerWithSite) => void;
}

export function BuildingDetailsPanel({ customer, details, loading, canDelete, onEdit, onDelete }: Props) {
  return (
    <div>
      <div className="admin-requests--panel-heading">
        <h4 className="heading heading__title--building mt-0">{customer.customerName || `Customer ${customer.id}`}</h4>
      </div>
      <div><strong>Address:</strong> {[customer.address1, customer.address2].filter(Boolean).join(", ") || "—"}</div>
      <div><strong>Town/City:</strong> {customer.townCity || "—"}</div>
      <div><strong>Postcode:</strong> {customer.postCode || "—"}</div>
      <div className="mt-1">
        <strong>Sites ({details?.sites.length ?? "..."}):</strong>
        {loading ? <div>Loading sites…</div> : !details ? <div>Sites unavailable</div> : (
          <div className="panel-box"><div className="tags tags--sites">
            {details.sites.length ? details.sites.map(site => (
              <a key={site.id} href={`/sites/${site.id}`} className="site-tag" onClick={event => event.stopPropagation()}>
                <span>{site.siteName || site.displayName || `Site ${site.id}`}</span>
              </a>
            )) : <div>No sites</div>}
          </div></div>
        )}
      </div>
      <div className="mt-1">
        <strong>Rules ({details?.rules.length ?? "..."}):</strong>
        {loading ? <div>Loading rules…</div> : !details ? <div>Rules unavailable</div> : (
          <div className="panel-box"><div className="tags tags--rules">
            {details.rules.length ? details.rules.map(rule => (
              <button key={rule.siteRuleId} type="button" onClick={event => event.stopPropagation()}
                className={`rule-tag ${(rule.isActive ?? true) ? "" : "rule-tag--inactive"}`}>
                <span>{rule.ruleName || `Rule ${rule.siteRuleId}`}</span>
              </button>
            )) : <div>No rules</div>}
          </div></div>
        )}
      </div>
      <div className="admin-requests__buttons">
        <Link className="btn btn-view" to={`/customers/customer-${customer.id}`}>View Customer</Link>
        <button className="btn btn-edit" onClick={() => onEdit(customer)}>Edit</button>
        {canDelete && details?.sites.length === 0 && (
          <button className="btn btn__error" onClick={() => onDelete(customer)}>Delete</button>
        )}
      </div>
    </div>
  );
}
